import { TypeInitProps, TypeRequest } from '../../types';
import { WEB_URL } from '../../utils/urls';

export default class QrCodeLoginAPI {
  private request: TypeRequest;
  constructor(props: TypeInitProps & { request: TypeRequest }) {
    const { request } = props;
    this.request = request;
  }
  /**
   * [get qrcode url]
   * @param {string} next redirect url after login success
   */
  getQrcode(params: { next: string }): Promise<any> {
    const { next } = params;
    return this.request({
      url: `${WEB_URL.GET_QRCODE}?next=${encodeURIComponent(next)}`,
      method: 'GET',
      // data: {
      //   next: encodeURIComponent(next),
      // },
    });
  }

  /**
   * [query qrCode status]
   * @param {string} next	 redirect url after login success
   * @param {string} token result of GetQrcode
   */
  public checkQrconnect(params: {
    next: string;
    token: string;
    baseURL: string;
  }): Promise<any> {
    let { next, token, baseURL = '' } = params;
    return this.request({
      url: `${baseURL}${WEB_URL.CHECK_QRCONNECT}?next=${encodeURIComponent(
        next
      )}`,
      method: 'GET',
      data: {
        // next: encodeURIComponent(next),
        token,
      },
    });
  }
}
